import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { preconApi } from "../lib/api";

const ITEMS = [
  ["scopes_match", "Scopes won match the estimate"],
  ["pricing_adjusted", "Quantities and pricing adjusted to the awarded scope"],
  ["handoff_sent", "Handoff email sent through the framework"],
];

/** BID MASTER §6 — Mark reconciled: the three-item checklist, pre-filled, every item required. */
export default function ReconcileDialog({ job, onClose, onDone }) {
  const [checks, setChecks] = useState({ scopes_match: true, pricing_adjusted: true, handoff_sent: true });
  const [busy, setBusy] = useState(false);
  const allOn = ITEMS.every(([k]) => checks[k]);
  const submit = async () => {
    setBusy(true);
    try { await preconApi.reconcileComplete(job.id, checks); toast.success("Reconcile complete — archived as Won"); onDone?.(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not mark reconciled"); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="reconcile-dialog">
        <DialogHeader>
          <DialogTitle>Reconcile complete · {job.project_name}</DialogTitle>
          <DialogDescription>Confirms the three checks, sets Won on the bid and the estimate, logs who and when, and archives the project.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {ITEMS.map(([k, label]) => (
            <label key={k} className="flex items-center gap-2 text-sm" data-testid={`reconcile-item-${k}`}>
              <Checkbox checked={!!checks[k]} onCheckedChange={(v) => setChecks((c) => ({ ...c, [k]: !!v }))} data-testid={`reconcile-check-${k}`} />
              {label}
            </label>))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="reconcile-cancel">Cancel</Button>
          <Button onClick={submit} disabled={!allOn || busy} data-testid="reconcile-submit">Reconcile complete</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
